import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * ひぐらしのなく頃に専用のHeaderコンポーネント
 * @param {Object} props
 * @param {string} props.title - メインタイトル（例："My Page"）
 * @param {string} props.subtitle - サブタイトル（例："鬼隠し編"）
 * @param {string} [props.highlightedWord] - 赤色でハイライトする単語（例："P"）
 * @param {number} [props.marginBottom=6] - 下部マージン
 * @returns {React.ReactElement}
 */
const Header = ({ title, subtitle, highlightedWord = null, sx }) => {
  const theme = useTheme();

  // タイトル内のハイライト単語を処理する関数
  const renderTitle = () => {
    if (!highlightedWord) {
      return title;
    }

    const parts = title.split(new RegExp(`(${escapeRegExp(highlightedWord)})`, "g"));

    return parts.map((part, index) => {
      if (part === highlightedWord) {
        return (
          <span key={index} style={{ color: theme.system.colors.red }}>
            {part}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <Box sx={{ textAlign: "center", ...sx }}>
      <Typography sx={(theme) => ({ ...theme.components.pageHeader })}>
        {renderTitle()}
      </Typography>
      {subtitle && (
        <Typography
          sx={(theme) => ({
            fontFamily: theme.system.fonts.brush,
            fontSize: "16px",
            marginTop: -1,
          })}
        >
          - {subtitle} -
        </Typography>
      )}
    </Box>
  );
};

export default Header;
